import { render, staticRenderFns } from "./zip-file-svg.vue?vue&type=template&id=3d84cb72&scoped=true&"
var script = {}
import style0 from "./zip-file-svg.vue?vue&type=style&index=0&id=3d84cb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d84cb72",
  null
  
)

export default component.exports